const PrivacyPolicy = () => {
  return (
    <div style={{ padding: "2rem", maxWidth: "800px", margin: "0 auto", fontFamily: "sans-serif", lineHeight: 1.6 }}>
      <h1>Privacy Policy</h1>
      <p>Effective Date: October 1, 2025</p>

      <p>We value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your data when you use our website or services.</p>

      <h2>Information We Collect</h2>
      <ul>
        <li>Personal information you provide to us directly, such as your name and email address.</li>
        <li>Information collected automatically, including your IP address and usage data.</li>
      </ul>

      <h2>How We Use Your Information</h2>
      <ul>
        <li>To provide and maintain our services.</li>
        <li>To communicate with you, including sending updates or promotional content if you opted in.</li>
        <li>To improve our website, services, and user experience.</li>
      </ul>

      <h2>Sharing Your Information</h2>
      <p>We do not sell your personal information. We may share information with trusted third-party service providers to help operate our website and services, subject to confidentiality obligations.</p>

      <h2>Cookies and Tracking</h2>
      <p>We may use cookies and similar technologies to enhance your experience on our website. You can manage or disable cookies in your browser settings.</p>

      <h2>Data Security</h2>
      <p>We implement reasonable administrative, technical, and physical measures to protect your personal information. However, no method of transmission over the Internet is 100% secure.</p>

      <h2>Changes to This Policy</h2>
      <p>We may update this Privacy Policy from time to time. We encourage you to review it periodically. Continued use of our services constitutes acceptance of any changes.</p>

      <h2>Contact Us</h2>
      <p>If you have any questions about this Privacy Policy, please contact us at <a href="mailto:log3holmi3@gmail.com">log3holmi3@gmail.com</a>.</p>
    </div>
  )
}

export default PrivacyPolicy;